import { render } from "./AlertModel.vue?vue&type=template&id=54c99cda"
import script from "./AlertModel.vue?vue&type=script&lang=js"
export * from "./AlertModel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__